// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const silkMoth = defineModel({
  id: "silk-moth",
  batchId: "future",
  name: "Silk moth",
  tags: ["creature","silk","moth","low-poly","age-of-mcp","future"],
  summary: "A silk moth — its cocoons are reeled into silk thread.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.06,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.006, 0.008, 0.06, 5), color: "#6a5238", position: [-0.02, 0.03, 0], rotation: [0, 0, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.003, 0.004, 0.025, 4), color: "#6a5238", position: [0.03, 0.05, 0.01], rotation: [0, 0, -0.7] },
      { geometry: new THREE.IcosahedronGeometry(0.013, 0), color: "#e6e0cf", position: [0.012, 0.07, 0], scale: [1.4, 1, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.011, 0), color: "#e6e0cf", position: [-0.012, 0.07, 0], scale: [1.6, 0.9, 0.9] },
      { geometry: new THREE.ConeGeometry(0.026, 0.05, 5), color: "#ece7d8", position: [0.006, 0.074, 0.014], rotation: [0, 0, 1.570796], scale: [1, 1, 0.18] },
      { geometry: new THREE.ConeGeometry(0.026, 0.05, 5), color: "#ece7d8", position: [0.006, 0.074, -0.014], rotation: [0, 0, 1.570796], scale: [1, 1, 0.18] },
      { geometry: new THREE.ConeGeometry(0.018, 0.034, 5), color: "#d2c8b0", position: [-0.014, 0.07, 0.012], rotation: [0, 0, 1.570796], scale: [1, 1, 0.18] },
      { geometry: new THREE.ConeGeometry(0.018, 0.034, 5), color: "#d2c8b0", position: [-0.014, 0.07, -0.012], rotation: [0, 0, 1.570796], scale: [1, 1, 0.18] },
      { geometry: new THREE.ConeGeometry(0.004, 0.022, 4), color: "#bfb59c", position: [0.026, 0.084, 0.006], rotation: [0.3, 0, -0.7] },
      { geometry: new THREE.ConeGeometry(0.004, 0.022, 4), color: "#bfb59c", position: [0.026, 0.084, -0.006], rotation: [-0.3, 0, -0.7] },
      { geometry: new THREE.IcosahedronGeometry(0.0025, 0), color: "#181410", position: [0.024, 0.07, 0.007] },
      { geometry: new THREE.IcosahedronGeometry(0.0025, 0), color: "#181410", position: [0.024, 0.07, -0.007] },
    ],
  animations: [],
});
